// material-ui
import { withStyles } from "@material-ui/core/styles";
// custom
import Table from "components/Table";
import PropTypes from "prop-types";
import React, { Component } from "react";
// styles
import styles from "./styles";

class DegreeRequirementsList extends Component {
  static propTypes = {
    classes: PropTypes.object,
    degreeRequirements: PropTypes.array,
    onSelect: PropTypes.func,
  };

  onSelect(selectedDegreeRequirement) {
    const { onSelect } = this.props;
    this.setState({ selectedDegreeRequirement });
    if (onSelect) {
      onSelect(selectedDegreeRequirement);
    }
  }

  render() {
    const { degreeRequirements } = this.props;

    return (
      <Table
        data={degreeRequirements}
        meta={[
          {
            path: "value",
            title: "Value",
            numeric: false,
          },
        ]}
        title={"Education Requirements"}
        onRowSelect={this.onSelect.bind(this)}
      />
    );
  }
}

export default withStyles(styles)(DegreeRequirementsList);
